import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";
import SendIcon from "@mui/icons-material/Send";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import { Link } from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import FormGroup from "@mui/material/FormGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Loader from "components/Loader";
import axios from "config/axios";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function ViewTest({ url }) {
  const { courseId, testId } = useParams();

  const [testDetails, setTestDetails] = React.useState({
    title: "",
    passPercentage: "",
  });
  const [testUpdateDetails, setTestUpdateDetails] = React.useState({
    title: "",
    passPercentage: "",
  });
  const [testUpdateModalOpen, setTestUpdateModalOpen] = useState(false);

  const [questionCreateModalOpen, setQuestionCreateModalOpen] =
    React.useState(false);
  const [questions, setQuestions] = useState(null);
  const [questionStatement, setQuestionStatement] = useState(null);
  const [option1, setOption1] = useState(null);
  const [option2, setOption2] = useState(null);
  const [option3, setOption3] = useState(null);
  const [option4, setOption4] = useState(null);
  const [answer, setAnswer] = useState(null);
  const [questionNo, setQuestionNo] = useState(0);
  const [isNewQuestionCreated, setIsNewQuestionCreated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleAnswerChange = (event, option) => {
    if (event.target.checked) {
      setAnswer(option);
    } else {
      setAnswer(null);
    }
  };

  const handleInputChange = (e) => {
    const name = e.target.name; // Access name directly
    const value = e.target.value;
    setTestUpdateDetails((prev) => ({ ...prev, [name]: value }));
    console.log("name", name, "value", value);
    console.log("testUpdateDetails", testUpdateDetails);
  };

  const handleTestUpdate = async () => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/courses/test/${testId}`,
        {
          title: testUpdateDetails.title,
          passPercentage: testUpdateDetails.passPercentage,
        }
      );
      console.log("test response", response);

      if (response.data.success) {
        toast.success("Test details updated successfully");
      }
    } catch (error) {
      toast.success("Error updating test details");
    }
    setTestUpdateModalOpen(false);
  };

  const fetch = async () => {
    setIsLoading(true);
    // Fetching the test details
    let response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/courses/test/${testId}`
    );
    if (response.data.success) {
      let test = {
        title: response.data.test.title,
        passPercentage: response.data.test.passPercentage,
      };
      setTestDetails(test);
      setTestUpdateDetails(test);
    }
    // Fetching test questions

    response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/courses/test/question/all/${testId}`
    );
    if (response.data.success) {
      const sortedQuestions = response.data.questions.sort(
        (a, b) => a.questionNo - b.questionNo
      );
      setQuestions(sortedQuestions);
    }
    setIsLoading(false);
  };


  const handleDeleteQuestion = async (questionId) => {
    try {
      setIsLoading(true);
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/api/courses/test/question/${questionId}`
      );

      // Extract `data` from response
      const { success, message } = response.data;

      if (success) {
        toast.success(message);
        fetch();
      } else {
        toast.error(message || "Something went wrong!");
      }

    } catch (error) {
      console.error("Error deleting question:", error);
      toast.error("Failed to delete question.");
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    fetch();
  }, [isNewQuestionCreated]);

  const handleCreate = async () => {
    let options = [];
    if (option1 !== null) options.push(option1);
    if (option2 !== null) options.push(option2);
    if (option3 !== null) options.push(option3);
    if (option4 !== null) options.push(option4);
    let correctAnswer;
    if (answer === "option1") correctAnswer = option1;
    else if (answer === "option2") correctAnswer = option2;
    else if (answer === "option3") correctAnswer = option3;
    else if (answer === "option4") correctAnswer = option4;
    const body = {
      statement: questionStatement,
      options: options,
      answer: correctAnswer,
      questionNo: questionNo,
      testId: testId,
    };
    console.log(body);
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/courses/test/question/add`,
      body
    );
    setIsNewQuestionCreated(!isNewQuestionCreated);
    setQuestionCreateModalOpen(false);
  };

  const isValid = !(
    questionStatement &&
    option1 &&
    option2 &&
    option3 &&
    option4 &&
    answer
  );

  if (!isLoading) {
    return (
      <div className="bg-white p-4">
        {/* Back Button */}
        <div className="flex justify-start items-center mb-4">
          <Link to={`${url}/courses/${courseId}/modules/create`}>
            <Button
              variant="contained"
              startIcon={<FastRewindIcon />}
            >
              Back
            </Button>
          </Link>
        </div>

        {/* Test Details Header */}
        <div className="flex justify-center items-center my-4">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 text-center">
            Test Details
          </h2>
        </div>

        {/* Test Card */}
        <div className="flex justify-center">
          <div className="w-full max-w-md md:max-w-2xl shadow-lg rounded overflow-hidden">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center px-4 py-3 border-b">
              <div className="text-lg font-bold mb-2 sm:mb-0">{testDetails?.title}</div>
              <button
                className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 rounded"
                onClick={() => setTestUpdateModalOpen(true)}
              >
                Edit
              </button>
            </div>

            {/* Test Update Modal */}
            <Modal
              open={testUpdateModalOpen}
              onClose={() => setTestUpdateModalOpen(false)}
              className="flex justify-center items-center"
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  bgcolor: "background.paper",
                  border: "2px solid #000",
                  boxShadow: 24,
                  p: 4,
                }}
              >
                <Typography variant="h6">Enter Test Details</Typography>

                <TextField
                  className="w-full mt-4"
                  label="Test Title"
                  variant="outlined"
                  name="title"
                  onChange={handleInputChange}
                  value={testUpdateDetails?.title}
                />

                <TextField
                  className="w-full mt-4"
                  label="Passing Percentage"
                  type="number"
                  name="passPercentage"
                  variant="outlined"
                  onChange={handleInputChange}
                  value={testUpdateDetails?.passPercentage}
                />

                <div className="flex justify-end gap-2 mt-4">
                  <Button variant="contained" onClick={handleTestUpdate}>Edit</Button>
                  <Button variant="contained" onClick={() => setTestUpdateModalOpen(false)}>Close</Button>
                </div>
              </Box>
            </Modal>
          </div>
        </div>

        {/* Add Question Section */}
        <div className="flex justify-center mt-6">
          <div className="w-full max-w-md md:max-w-2xl shadow-lg rounded overflow-hidden">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center px-4 py-3 border-b">
              <div className="text-lg font-bold mb-2 sm:mb-0">Add New Question</div>
              <button
                className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 rounded"
                onClick={() => setQuestionCreateModalOpen(true)}
              >
                Add Question
              </button>
            </div>

            {/* Question Create Modal */}

            <Modal
              open={questionCreateModalOpen}
              onClose={() => setQuestionCreateModalOpen(false)}
              className="flex items-center justify-center p-4"
            >
              <Box
                sx={{
                  bgcolor: 'background.paper',
                  borderRadius: 2,
                  boxShadow: 24,
                  p: { xs: 2, sm: 4 },
                  width: '100%',
                  maxWidth: '600px',
                  maxHeight: '90vh',
                  overflowY: 'auto',
                }}
              >
                <Typography variant="h5" mb={2}>
                  Question Form
                </Typography>
                <Box component="form">
                  <TextField
                    label="Question Statement"
                    name="questionStatement"
                    value={questionStatement}
                    onChange={(e) => setQuestionStatement(e.target.value)}
                    fullWidth
                    margin="normal"
                    multiline
                  />
                  {[option1, option2, option3, option4].map((opt, i) => (
                    <TextField
                      key={i}
                      label={`Option ${i + 1}`}
                      name={`option${i + 1}`}
                      value={opt}
                      onChange={(e) => eval(`setOption${i + 1}`)(e.target.value)}
                      fullWidth
                      multiline
                      margin="normal"
                    />
                  ))}
                  <Typography variant="h6" mt={2}>
                    Select Answer
                  </Typography>
                  <FormGroup>
                    {['option1', 'option2', 'option3', 'option4'].map((opt, i) => (
                      <FormControlLabel
                        key={opt}
                        control={
                          <Checkbox
                            color="primary"
                            onChange={(e) => handleAnswerChange(e, opt)}
                            checked={answer === opt}
                          />
                        }
                        label={`Option ${i + 1}`}
                      />
                    ))}
                  </FormGroup>
                  <TextField
                    label="Question Number"
                    name="questionNo"
                    value={questionNo}
                    onChange={(e) => setQuestionNo(e.target.value)}
                    fullWidth
                    type="number"
                    margin="normal"
                  />
                  <Box className="flex justify-end gap-2 mt-4">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleCreate}
                      disabled={isValid}
                    >
                      Add
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => setQuestionCreateModalOpen(false)}
                    >
                      Close
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Modal>

          </div>
        </div>

        {/* View Questions */}
        <div className="mt-6">
          <h2 className="text-center text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            View Questions
          </h2>

          <div className="w-full max-w-md md:max-w-2xl mx-auto shadow-lg rounded overflow-hidden">
            {questions && questions.length > 0 && questions.map((question) => (
              <div key={question?._id} className="px-4 py-3 flex flex-col md:flex-row sm:items-center justify-between border-b">
                <div className="text-lg font-bold mb-2 sm:mb-0">{question.statement}</div>
                <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-2 sm:space-y-0">
                  <Link to={`${url}/courses/${courseId}/test/${testId}/question/${question._id}`}>
                    <button
                      type="button"
                      className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 rounded">
                      View Question
                    </button>
                  </Link>
                  <button
                    type="button"
                    className="bg-red-500 hover:bg-red-400 text-white font-bold py-2 px-4 rounded"
                    onClick={() => handleDeleteQuestion(question._id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

    );
  } else {
    return <Loader />;
  }
}
